import Button, { ButtonProps } from "components/Button";
import Modal from "components/Modal";
import SlideModal, { SlideModalProps } from "components/SlideModal";
import { FC, useMemo } from "react";
import { useMediaQuery } from "react-responsive";
import { MAX_WIDTH_MOBILE } from "utils/constant";
import { ReactComponent as IconError } from "../../assets/error.svg";
import { ReactComponent as IconWarning } from "../../assets/warning.svg";
import { POPUP_STATUS } from "../../entities";
import styles from "./Popup.module.scss";

interface PopupProps {
  isOpen: boolean;
  title: React.ReactNode;
  content: React.ReactNode;
  status: POPUP_STATUS;
  closeTitle?: React.ReactNode;
  confirmTitle?: React.ReactNode;
  verticalButtons?: boolean;
  closeBtnProps?: Partial<ButtonProps>;
  confirmBtnProps?: Partial<ButtonProps>;
  onConfirm: () => void;
  onClose?: () => void;
  slideModalProps?: Partial<SlideModalProps>;
}

const Popup: FC<PopupProps> = ({
  isOpen,
  title,
  content,
  status,
  closeTitle,
  confirmTitle,
  verticalButtons,
  closeBtnProps,
  confirmBtnProps,
  onConfirm,
  onClose,
  slideModalProps,
}) => {
  const isMobile = useMediaQuery({ maxWidth: MAX_WIDTH_MOBILE });

  const popup = useMemo(
    () => (
      <div className={styles.container}>
        <div className={styles.title}>
          {status === POPUP_STATUS.WARNING ? <IconWarning /> : <IconError />}
          <span>{title}</span>
        </div>
        <div className={styles.content}>{content}</div>

        <div
          className={`${styles.buttons} ${
            verticalButtons ? styles.vertical : ""
          }`}
        >
          {onClose ? (
            <Button
              onClick={onClose}
              {...{ type: "tertiary", ...closeBtnProps }}
            >
              {closeTitle}
            </Button>
          ) : (
            <div></div>
          )}
          {onConfirm ? (
            <Button
              onClick={onConfirm}
              {...{ type: "primary", ...confirmBtnProps }}
            >
              {confirmTitle}
            </Button>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    ),
    [
      status,
      title,
      content,
      onClose,
      closeTitle,
      onConfirm,
      confirmTitle,
      closeBtnProps,
      confirmBtnProps,
      verticalButtons,
    ]
  );

  return isMobile ? (
    <SlideModal
      isOpen={isOpen}
      onClose={status === POPUP_STATUS.WARNING ? onClose : () => {}}
      {...slideModalProps}
    >
      {popup}
    </SlideModal>
  ) : (
    <Modal isOpen={isOpen}>{popup}</Modal>
  );
};
export default Popup;
